import { connect } from 'react-redux'

import { getPhoto } from '@selectors/data/photo_selectors.js'

import { paginateTo, loadUserPhotos, uploadPhotos, deletePhoto } from '../actions/client_actions.js'
import { getCurrentPage, getPagination, getPhotoDeletions, getUploading } from '../reducers/index.js'
import PhotoLibrary from '../components/photo_library.jsx'

const mapStateToProps = (state, props) => {
  const { onSelectItem } = props
  const currentPage = getCurrentPage(state)
  const pagination = getPagination(state, { page: currentPage })

  const photoIds = pagination ? pagination.ids : []
  const photos = photoIds.map(id => getPhoto(state, { photoId: id }))
  const uploading = getUploading(state)
  const photoDeletions = getPhotoDeletions(state)
  return {
    currentPage,
    pagination,
    photos,
    onSelectItem,
    photoDeletions,
    uploading,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const apiVersion = props.apiVersion || 1
  return {
    loadUserPhotos: payload => {
      dispatch(loadUserPhotos(payload, apiVersion))
    },
    onSelectFilesToUpload: files => {
      dispatch(uploadPhotos(files, apiVersion))
    },
    onDeleteItem: id => {
      dispatch(deletePhoto(id, apiVersion))
    },
    onPaginate: pageNumber => {
      dispatch(loadUserPhotos(pageNumber, apiVersion))
      dispatch(paginateTo(pageNumber, apiVersion))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotoLibrary)
